import * as React from 'react';

import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'border-input bg-background placeholder_text-muted-foreground !placeholder_font-light flex  min-h-[80px] w-full border px-3 py-2 text-sm placeholder_font-roboto-light placeholder_text-[16px] focus_border-primary disabled_cursor-not-allowed disabled_opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';

export { Textarea };
